<template lang="pug">
  .changelog
    section
      .max-width
        .breadcrumbs(v-if="isApp")
          ul
            li
              router-link.primary-link(:to="{ name: isAdmin ? 'AdminDashboard' : 'PublicDashboard'}") Dashboard
            li
              span \
            li
              span Changelogs

    section
      .max-width
        .row
          .col.max
            header.changelog-header
              h2 Changelogs

            ChangelogPreview(v-for="changelog in changelogs", :changelog="changelog", :key="changelog._id")
          .col.sidebar
            aside
              .sidebar-section
                router-link.button.primary-button(:to="{name: 'ChangelogCreate'}") Create Changelogs

</template>

<script>

import { mapState } from 'vuex'

import ChangelogPreview from '@/components/ChangelogPreview'

export default {
  name: 'AdminChangelog',
  components: {
    ChangelogPreview
  },
  data () {
    return {
    }
  },
  beforeMount () {
    console.log('admin changeloga')
    this.getChangelogs()
  },
  computed: {
    ...mapState({
      company: state => state.company,
      changelogs: state => state.changelogs.list
    }),
    isAdmin () {
      return this.$route.matched[0].meta.member
    },
    isApp () {
      //console.log(this.$route)
      return !(this.$route.meta && this.$route.meta.widget)
    }
  },
  methods: {
    getChangelogs () {
      this.$store.dispatch('changelogs/getChangelogs')
    }
  },
  watch: {
  }
}

</script>

<style lang="stylus" scoped>
.changelog-header
  margin-bottom $spacing-3
  h2
    color $color-primary
aside
  border $border-default
  border-radius $border-radius
  margin-left $spacing-3
  width 370px
  .sidebar-section
    padding $spacing-3

</style>
